// src/pages/JuryByYear.jsx
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import IntroImage from '../images/192721015_ebb5e9a9-c897-4996-a1e1-5219ede67436.jpg';
import Jury1 from '../images/jury/jury_1.jpg';
import Jury2 from '../images/jury/jury_2.jpeg';
import Jury3 from '../images/jury/jury_3.jpg';
import Jury4 from '../images/jury/jury_4.jpg';
import Jury5 from '../images/jury/jury_5.jpg';
import Jury6 from '../images/jury/jury_6.jpg';
import Jury7 from '../images/jury/jury_7.png';
import Jury8 from '../images/jury/jury_8.jpg';
import Jury9 from '../images/jury/jury_9.jpeg';
import Jury10 from '../images/jury/jury_10.jpg';
import Jury11 from '../images/jury/jury_11.jpg';
import Jury12 from '../images/jury/jury_12.jpg';
import Jury13 from '../images/jury/jury_13.jpg';
import Jury14 from '../images/jury/jury_14.jpg';
import Jury15 from '../images/jury/jury_15.jpg';
import Jury16 from '../images/jury/jury_16.jpg';
import Jury17 from '../images/jury/jury_17.jpeg';
import Jury18 from '../images/jury/jury_18.jpeg';
import Jury19 from '../images/jury/jury_19.jpeg';
import Jury20 from '../images/jury/jury_20.jpg';
import Jury21 from '../images/jury/jury_21.jpg';

const juryByYear = [
  {
    year: '2019',
    members: [
      {
        name: 'Дмитрий Соломонов',
        manage: 'ЗАМЕСТИТЕЛЬ ПРЕДСЕДАТЕЛЯ ЖЮРИ',
        country: 'Россия',
        role: 'директор по маркетингу международного финтех-холдинга',
        photo: Jury1,
        bio: 'Ранее руководил региональными кампаниями в Восточной Европе и MENA. Обладает более чем 15-летним опытом в стратегическом маркетинге, трансформациях клиентского пути и запуске мультиканальных экосистем. Автор практик по интеграции AI в CRM-платформы.',
      },
      {
        name: 'Лаура Молдован',
        manage: 'ПРЕДСЕДАТЕЛЬ ЖЮРИ',
        country: 'Румыния',
        role: 'сооснователь и управляющий партнёр агентства CX&Partners',
        photo: Jury2,
        bio: 'Агентство специализируется на опыте потребителя и digital-трансформации. Под её руководством агентство реализовало более 40 международных кампаний для брендов из списка Fortune 500. Лауреат премии Webby Awards и член WARC.',
      },
      {
        name: 'Аян Курманов',
        manage: 'ЗАМЕСТИТЕЛЬ ПРЕДСЕДАТЕЛЯ ЖЮРИ',
        country: 'Казахстан',
        role: 'CMO агропромышленного холдинга',
        photo: Jury3,
        bio: 'Внедрил сквозную систему оценки ROI на всех уровнях коммуникации. Один из первых в регионе внедрил машинное обучение для прогнозирования поведения клиентов. Регулярный спикер Eurasian Marketing Forum.',
      },
      {
        name: 'Тамара Янкович',
        country: 'Сербия',
        role: 'эксперт по стратегическому брендингу',
        bio: 'Консультант для UNDP по вопросам коммуникации в зонах риска. Обладатель степени PhD в области когнитивных моделей восприятия бренда. Её исследования публиковались в Journal of Consumer Psychology.',
      },
      {
        name: 'Николас Тарраго',
        country: 'Франция',
        role: 'независимый арт-директор и куратор междисциплинарных проектов в секторе luxury и культуры',
        bio: 'Член международного жюри Cannes Lions и Golden Drum. Работает с Dom Pérignon, Hermès и Музеем современного искусства Парижа.',
      },
      {
        name: 'Юлия Веденеeва',
        country: 'Беларусь',
        role: 'основатель агентства UBrand Consulting',
        bio: 'Признанного лучшим локальным брендинговым агентством по версии East Branding Index. Имеет опыт работы с брендами в 8 странах СНГ и Балтии. Её команда получила Effie Bronze за стратегию repositioning',
      },
      {
        name: 'Арсен Мовсисян',
        country: 'Армения',
        role: 'директор по маркетингу крупнейшего мобильного оператора региона',
        bio: 'Возглавил переход к data-driven модели. Разработал платформу customer segmentation, признанную инновацией года в отрасли. Участвовал в Global Marketing Day.',
      },
      {
        name: 'Виктория Лакатош',
        country: 'Молдова',
        role: 'эксперт по контент-стратегии и внутренним коммуникациям в B2B-секторе',
        bio: 'Является приглашённым лектором в Академии коммуникаций Вены и автором публикаций в Harvard Business Review Eastern Europe Edition.',
      },
      {
        name: 'Андреа Сальви',
        country: 'Италия',
        role: 'профессор маркетинга в LUISS Business School',
        bio: 'Эксперт в области когнитивной нейроэкономики и влияния визуальной рекламы. Входит в состав редколлегии European Journal of Marketing. Консультирует крупные банки и fashion-компании.',
      },
      {
        name: 'Наталья Сугак',
        country: 'Украина',
        role: 'управляющая digital-агентством полного цикла',
        bio: 'Реализовавшим проекты в 12 странах. Владеет сертификацией ESOMAR и активно участвует в локализации международных брендов для рынков Восточной Европы. Участник MIXX Awards Europe.',
      },
      {
        name: 'Гийом Брессон',
        country: 'Бельгия',
        role: 'консультант по коммуникациям в сфере устойчивого развития и ESG',
        bio: 'Возглавлял международные PR-кампании в WWF и UN Global Compact. Регулярно выступает на конференциях World Communication Forum и Sustainable Brands.',
      },
      {
        name: 'Зарема Абдулова',
        country: 'Азербайджан',
        role: 'специалист по PR и институциональному маркетингу',
        bio: 'Продвигает университетские и культурные бренды на международной арене. Преподаёт маркетинговые коммуникации в Бакинской школе бизнеса. Автор пособия по международному брендингу в академическом секторе.',
      },
    ],
  },
  {
    year: '2020',
    members: [
      {
        name: 'Леонид Вершинин',
        manage: 'ЗАМЕСТИТЕЛЬ ПРЕДСЕДАТЕЛЯ ЖЮРИ',
        country: 'Россия',
        photo: Jury4,
        role: 'вице-президент по маркетингу транснационального холдинга в области потребительской электроники',
        bio: 'Имеет более 15 лет опыта в международном маркетинге, включая проекты в Европе и Азии. Руководил запуском глобального ребрендинга с выходом на рынки MENA. Постоянный участник Web Summit и член The Marketing Society.',
      },
      {
        name: 'Теа Чантурия',
        manage: 'ПРЕДСЕДАТЕЛЬ ЖЮРИ',
        country: 'Грузия',
        photo: Jury5,
        role: 'соучредительница и креативный директор агентства TBC Creatives',
        bio: 'Работающего с брендами из сферы моды, туризма и винодельческой промышленности. Реализовала масштабные кампании, отмеченные наградами ADC*E и Golden Drum. Автор публикаций о культурной адаптации брендов в кросс-региональных кампаниях.',
      },
      {
        name: 'Роберт Лисовски',
        manage: 'ЗАМЕСТИТЕЛЬ ПРЕДСЕДАТЕЛЯ ЖЮРИ',
        country: 'Польша',
        photo: Jury6,
        role: 'профессор маркетинга в Kozminski University',
        bio: 'Автор более 40 научных публикаций в Journal of Marketing Theory и WARC. Специализируется на поведенческой экономике, нейромаркетинге и digital-экспериментах. Руководил международным исследованием по восприятию брендов в странах Восточной Европы.',
      },
      {
        name: 'Мариам Зубашвили',
        country: 'Армения',
        role: 'CMO в финтех-экосистеме',
        bio: 'Ранее работала с международными венчурными фондами в Лондоне и Тель-Авиве. Эксперт по запуску брендов с нуля и построению digital-команд в стартап-среде. Участница Global Marketing Day, ментор для женщин в маркетинге в рамках программы EBRD.',
      },
      {
        name: 'Фернандо Альварес',
        country: 'Испания',
        role: 'управляющий партнёр международного агентства Menta&Data',
        bio: 'Специализирующегося на CX и перформанс-маркетинге. Работал с такими брендами, как Iberia, HP и Danone. Жюри WARC Awards и MIXX Europe. Преподаёт в IE Business School.',
      },
      {
        name: 'Людмила Киселёва',
        country: 'Беларусь',
        role: 'эксперт по B2B-коммуникациям, CMO крупного промышленного холдинга',
        bio: 'Разработала систему управления маркетинговой аналитикой на базе BI. Автор статей о digital-вовлечении в сфере машиностроения. Член IAA Belarus и приглашённый лектор в БГУИР.',
      },
      {
        name: 'Михал Ондрашек',
        country: 'Чехия',
        role: 'руководитель департамента маркетинга в старейшей страховой компании Центральной Европы',
        bio: 'Запустил кросс-канальную экосистему персонализированной коммуникации, которая увеличила вовлечённость клиентов на 70%. Участник Global CMO Council и спикер на конференциях по InsurTech.',
      },
      {
        name: 'Сабина Мамедова',
        country: 'Азербайджан',
        role: 'бренд-стратег и управляющая партнёр агентства SaMa Agency',
        bio: 'Имеет более 10 лет опыта в брендинге, вела проекты для международных компаний в сфере недвижимости и энергетики. Лауреат премии Design Europe 2019, участница жюри Epica Awards.',
      },
      {
        name: 'Томас Жирар',
        country: 'Франция',
        role: 'профессор брендинга в ESCP Business School, PhD',
        bio: 'В области эмоционального восприятия брендов. Руководит исследовательским проектом "Sustainable Brand Futures", публикуется в Harvard Business Review. Консультировал несколько европейских министерств по вопросам nation branding.',
      },
      {
        name: 'Алия Нуртаева',
        country: 'Казахстан',
        role: 'директор по маркетингу в агротехнологической компании',
        bio: 'Продвигающей устойчивые решения для сельского хозяйства. Внедрила ESG-коммуникации и разработала кампанию, отмеченную региональной премией. Постоянный автор колонки о green marketing в Central Asia Business Review.',
      },
      {
        name: 'Иоанн Руссу',
        country: 'Румыния',
        role: 'Head of Digital Strategy в международной сети агентств',
        bio: 'Ранее работал в BBDO и Dentsu. Возглавлял digital-кампании в 8 странах Центральной и Восточной Европы. Жюри Cannes Lions и Digital Communication Awards. Активный член IAB Europe.',
      },
      {
        name: 'Сандра Новак',
        country: 'Словакия',
        role: 'директор по бренд-коммуникациям в телеком-секторе',
        bio: 'Разработала платформу омниканального позиционирования. Участвовала в редизайне ключевых B2C-продуктов на трёх рынках. Ментор в инициативе Women in Tech и приглашённый спикер на конференции Digital Europe 2020.',
      },
    ],
  },
  {
    year: '2021',
    members: [
      {
        name: 'Андреас Шульц',
        manage: 'ЗАМЕСТИТЕЛЬ ПРЕДСЕДАТЕЛЯ ЖЮРИ',
        country: 'Германия',
        photo: Jury7,
        role: 'вице-президент по маркетингу фармацевтической корпорации',
        bio: 'Работающей в более чем 40 странах. Руководил трансформацией клиентского пути с акцентом на цифровую воронку, что позволило увеличить вовлеченность HCP-аудиторий на 55%. Регулярный спикер на форумах Digital Pharma Europe и участник AMA Europe. Является членом CMO Council и ментором в European Leadership Program.',
      },
      {
        name: 'Вадим Лариков',
        manage: 'ПРЕДСЕДАТЕЛЬ ЖЮРИ',
        country: 'Украина',
        photo: Jury8,
        role: 'директор по маркетингу агентства UAMASTER с 2019 года',
        bio: 'Специализирующегося на digital-стратегиях, performance-маркетинге и внедрении ESG-подходов в бизнес-практику. Автор научной публикации об устойчивом маркетинге, обладатель патента на платформу прогностической аналитики на основе мультиканальных данных. Победитель в главной номинации Global Marketing Awards 2019 и лауреат конкурса Digital Horizon в категории «Стратег года». Регулярно выступает на профессиональных форумах и публикуется в отраслевых изданиях.',
      },
      {
        name: 'Роланд Яновскис',
        manage: 'ЗАМЕСТИТЕЛЬ ПРЕДСЕДАТЕЛЯ ЖЮРИ',
        country: 'Латвия',
        photo: Jury9,
        role: 'директор по стратегическому маркетингу в международной финтех-компании, работающей на рынках ЕС и Юго-Восточной Азии',
        bio: 'Эксперт в области loyalty-моделей и поведенческого анализа. Имеет степень MBA Лондонской школы бизнеса и публикуется в Journal of Digital Consumer Research. Участвовал в разработке кросс-рыночной платформы на базе open banking.',
      },
      {
        name: 'Нино Микадзе',
        country: 'Грузия',
        role: 'директор по коммуникациям крупной инвестиционной группы, активно вовлечённой в развитие культурных и социальных инициатив',
        bio: 'Создала коммуникационную стратегию для национальной инициативы по культурному наследию, отмеченную премией Golden Hammer. Эксперт в области культурных коммуникаций и социальной репутации бренда.',
      },
      {
        name: 'Пётр Беленский',
        country: 'Украина',
        role: 'профессор кафедры маркетинга Киевской школы экономики',
        bio: 'Автор монографий по цифровой трансформации брендов и инновациям в CX. Исследует поведение молодёжных аудиторий и влияние нейросетей на рекламные предпочтения. Приглашённый спикер на конференциях WARC и ESOMAR. Курировал международный исследовательский проект по ESG-коммуникациям в Центральной Европе.',
      },
      {
        name: 'Аиша Мухтарова',
        country: 'Узбекистан',
        role: 'CMO в логистической платформе, охватывающей рынки Центральной Азии и Закавказья',
        bio: 'Внедрила систему автоматизированной аналитики и омниканальных кампаний на базе AI. Победительница премии “Central Asia Marketing Achievements 2020”. Публикуется в отраслевых изданиях на английском и русском языках.',
      },
      {
        name: 'Йоана Доброва',
        country: 'Болгария',
        role: 'креативный директор студии Digital Form',
        bio: 'Лауреат European Design Awards и член Epica Jury. Разработала визуальные идентичности для брендов из сегмента устойчивого потребления. Консультирует компании в области UX-стратегий и digital sustainability. Часто выступает на форумах по экологичному маркетингу и женскому лидерству в индустрии.',
      },
      {
        name: 'Кристоф Делакруа',
        country: 'Франция',
        role: 'Head of Content Innovation в одном из крупнейших европейских издательств',
        bio: 'Продвигает нативные форматы, сторителлинг и интерактивные платформы на базе ИИ. Входил в состав жюри Webby Awards и Lovie Awards. Читает курсы по трансмедийной стратегии в Sciences Po Paris.',
      },
      {
        name: 'Диана Тимощенко',
        country: 'Беларусь',
        role: 'директор по развитию бренда в национальной сети аптек',
        bio: 'Специализируется на омниканальном ритейле. Разработала и внедрила экосистему e-detailing с персонализированным взаимодействием. Участвовала в адаптации международных стратегий для локальных рынков. Член IAA и региональный координатор инициативы «Маркетинг для здоровья».',
      },
      {
        name: 'Альберт Ковач',
        country: 'Словакия',
        role: 'консультант по брендингу и исследователь',
        bio: 'Бывший партнёр агентства, работавшего с Volkswagen, Orange и OTP Bank. Автор работ по восприятию бренда в условиях турбулентности. Читает лекции в University of Economics in Bratislava, член Digital Analytics Association.',
      },
      {
        name: 'Сандра Мартинес',
        country: 'Испания',
        role: 'управляющий партнёр CX-агентства',
        bio: 'Проекты для гостиничного и авиасектора в Европе и Южной Америке. Руководила внедрением платформ клиентской лояльности для сети международных отелей. Часто выступает на Customer Experience World и Hotel Tech Live.',
      },
      {
        name: 'Микаэль Фарелли',
        country: 'Италия',
        role: 'CMO SaaS-стартапа HR-tech',
        bio: 'Отвечал за выход на рынки Германии, Польши и Австрии с локализованными digital-воронками. Имеет опыт работы в международных командах и владеет пятью языками. Участник сессий Digital Leadership и EMEA CMO Exchange.',
      },
    ],
  },
  {
    year: '2022',
    members: [
      {
        name: 'Лидия Полещук',
        manage: 'ЗАМЕСТИТЕЛЬ ПРЕДСЕДАТЕЛЯ ЖЮРИ',
        country: 'Украина',
        photo: Jury10,
        role: 'вице-президент по маркетингу в агрохолдинге с экспортом в 15 стран',
        bio: 'Отвечает за стратегию роста брендов в сфере food-tech и AgriBI. Разработала BI-платформу для оценки эффективности коммуникаций, использующую показатели потребления и точечную аналитическую атрибуцию. Постоянный участник ESOMAR Congress и соавтор исследования «Агромаркетинг в эпоху продовольственных кризисов». Активно публикуется в отраслевых изданиях Европы и СНГ.',
      },
      {
        name: 'Ричард Мейерс',
        manage: 'ПРЕДСЕДАТЕЛЬ ЖЮРИ',
        country: 'Нидерланды',
        photo: Jury11,
        role: 'основатель креативной группы Pattern & Cause',
        bio: 'Реализовавшей кампании для Heineken, Booking и ING. Его работы отмечены наградами ADCN, Eurobest и Webby. Специализируется на стратегии устойчивого потребления и кросс-платформенных цифровых экосистемах. Член голландского отделения The Marketing Society и ментор в программе Amsterdam Creative Lab.',
      },
      {
        name: 'Амина Ермекова',
        manage: 'ЗАМЕСТИТЕЛЬ ПРЕДСЕДАТЕЛЯ ЖЮРИ',
        country: 'Казахстан',
        photo: Jury12,
        role: 'директор по маркетингу в девелоперской компании с ESG-повесткой',
        bio: 'Руководила брендингом нового жилого кластера с нулевым углеродным следом и сформировала digital-экосистему для привлечения инвесторов. Представляла Казахстан на Global Marketing Sustainability Forum в Берлине. Активно развивает образовательную инициативу для молодых маркетологов в Центральной Азии.',
      },
      {
        name: 'Джордж Страттон',
        country: 'Великобритания',
        role: 'профессор маркетинга в Imperial College London',
        bio: 'Автор более 30 научных публикаций по поведенческому таргетингу и digital persuasion. Один из экспертов, консультировавших кампании WARC в сфере эффективности данных и этики. Член редколлегии Harvard Business Review Europe и сооснователь инициативы Open Marketing Ethics.',
      },
      {
        name: 'Инеса Крупа',
        country: 'Литва',
        role: 'Head of Performance в международном агентстве с клиентами в Финляндии, США и странах Балтии',
        bio: 'Внедрила AI-алгоритмы в управление бюджетами по более чем 300 проектам. Победитель MIXX Awards Europe и член жюри Golden Hammer. Специализируется на оптимизации full-funnel и стратегии маркетинга на стадиях зрелости продукта.',
      },
      {
        name: 'Мариам Тенгизи',
        country: 'Грузия',
        role: 'стратег и продюсер культурных брендов, основательница платформы New Narratives',
        bio: 'Разработала репутационные кампании для Министерства культуры и брендов в сфере вина, туризма и ремесел. Входит в кураторский совет Georgian Creative Week и преподавала в ESM Tbilisi. Активистка в продвижении культурного маркетинга как инструмента устойчивого развития.',
      },
      {
        name: 'Ильгар Насибов',
        country: 'Азербайджан',
        role: 'руководитель центра digital-инноваций телеком-холдинга',
        bio: 'Отвечает за внедрение omnichannel-стратегий. Автор корпоративной платформы персонализированных коммуникаций, увеличившей ARPU на 34%. Приглашённый спикер конференций WFA и MENA Martech. Получил образование в Швейцарии, работает в Baku-London Hub.',
      },
      {
        name: 'Даниэла Монтекки',
        country: 'Италия',
        role: 'креативный директор и соосновательница агентства Linea Creativa',
        bio: 'Создавала award-winning кампании для люксовых брендов: Ferragamo, Illy, Bulgari. Регулярный член жюри ADCI и Epica Awards, лектор в Accademia di Comunicazione (Милан). Эксперт по брендингу и визуальным метафорам в digital storytelling.',
      },
      {
        name: 'Галина Власенко',
        country: 'Беларусь',
        role: 'руководитель департамента маркетинга в крупнейшей розничной аптечной сети',
        bio: 'Внедрила гибридную CRM-модель с поведенческой сегментацией. Специализируется на комплексных подходах к клиентскому пути в здравоохранении. Выступает на конференциях по фарма-маркетингу в Вильнюсе и Праге. Поддерживает программы маркетинга здоровья и образования пациентов.',
      },
      {
        name: 'Роберт Симеонеску',
        country: 'Румыния',
        role: 'digital-аналитик и автор обучающей программы по data-driven стратегиям в Университете Бухареста',
        bio: 'Сертифицированный специалист Google Analytics и Tableau, консультирует НКО и стартапы в области медицины и урбанистики. Участвовал в жюри Effie Romania и является членом IAA Romania. Активно вовлечён в проекты EU по Smart Cities.',
      },
      {
        name: 'Таня Коваль',
        country: 'Молдова',
        role: 'руководитель отдела креативных стратегий в media-агентстве',
        bio: 'Обслуживает рынки СНГ и Восточной Европы. Разработала кампании с вовлечением до 20 млн пользователей на YouTube и TikTok. Занимается обучением молодых специалистов в рамках проекта «Медиа для будущего». Публикуется на платформах AdIndex и Medium.',
      },
      {
        name: 'Камиль Гросье',
        country: 'Франция',
        role: 'директор по глобальной коммуникации в международной экологической НКО',
        bio: 'Ранее работал в Publicis Paris. Курировал digital-кампании с партнёрами ЮНЕСКО, WWF и IKEA. Член CMO Council и лауреат SDG Marketing Awards. Специализируется на коммуникациях в контексте устойчивого развития, кризисных PR и брендинга миссии.',
      },
    ],
  },
  {
    year: '2023',
    members: [
      {
        name: 'Сабина Вельтман',
        manage: 'ЗАМЕСТИТЕЛЬ ПРЕДСЕДАТЕЛЯ ЖЮРИ',
        country: 'Германия',
        photo: Jury13,
        role: 'вице-президент по маркетингу в глобальном фармацевтическом холдинге',
        bio: 'Управляющая портфелем из 20+ брендов на рынках Европы, Азии и Ближнего Востока. Под её руководством внедрена омниканальная стратегия коммуникаций с программируемыми видео и персонализированным e-mail-маркетингом. Член жюри Cannes Health Lions и спикер Global Pharma Marketing Summit. Интегрирует ESG-повестку в корпоративный бренд.',
      },
      {
        name: 'Томаш Новак',
        manage: 'ПРЕДСЕДАТЕЛЬ ЖЮРИ',
        country: 'Чехия',
        photo: Jury14,
        role: 'CEO и креативный директор Cubic Creative',
        bio: 'Студия специализируется на дизайне и брендинге для стартапов и технологических брендов. Победитель Red Dot, European Design Awards и ADC Czech Republic. Член TypoBerlin Conference, проводит интенсивы по визуальной идентичности в Восточной Европе. Автор курса «Brand Systems for Scale».',
      },
      {
        name: 'Кристина Айрапетян',
        manage: 'ЗАМЕСТИТЕЛЬ ПРЕДСЕДАТЕЛЯ ЖЮРИ',
        country: 'Армения',
        photo: Jury15,
        role: 'директор по стратегическим коммуникациям телеком-холдинга',
        bio: 'Охватывает рынки Кавказа и ЦА. Руководила запуском мультикультурной кампании, получившей Eurasia Communication Award. Член IAA Armenia и приглашённый эксперт в  программе для женщин-лидеров. Курирует акселерационные треки для CMO в TechNation Caucasus.',
      },
      {
        name: 'Питер Гарднер',
        country: 'США/Великобритания',
        role: 'профессор поведенческой экономики и маркетинга в University of Oxford',
        bio: 'Автор 50+ статей в Journal of Marketing Research, Nature Human Behaviour и HBR. Консультировал ООН и FMCG-бренды по потребительскому выбору и nudging. Судья WARC Awards, член The Marketing Society UK.',
      },
      {
        name: 'Роза Джуматаева',
        country: 'Киргизия',
        role: 'управляющая маркетингом в энергетической компании',
        bio: 'Первая в стране внедрила цифровую платформу для B2B и B2C. Возглавляла ESG-кампанию по энергоэффективности. Резидент WISE WOMEN in Energy Marketing, спикер саммита устойчивых коммуникаций в Вене. Автор программы по социальному маркетингу для госучреждений.',
      },
      {
        name: 'Иштван Ковач',
        country: 'Венгрия',
        role: 'стратег в европейском консалтинговом холдинге',
        bio: 'Разрабатывает коммуникационные стратегии для банков и телекомов. Специализируется на воронках и AI-персонализации. Участник European Martech Roundtable, жюри Effie Central Europe.',
      },
      {
        name: 'Лаура Брандейро',
        country: 'Португалия',
        role: 'основательница Studio L.B.',
        bio: 'Реализовала 100+ кампаний для fashion и гастро-брендов. Эксперт сторителлинга и эмоционального дизайна. Член Portuguese Creative Club, лектор Lisbon School of Design. Победитель Graphis и участник Design Indaba.',
      },
      {
        name: 'Мирослава Василенко',
        country: 'Украина',
        role: 'директор по digital-маркетингу в аграрно-технологической группе',
        bio: 'Внедрила mobile-first платформу управления спросом, кросс-канальную аналитику CRM+BI. Спикер Digital Transformation Ukraine, наставник «Женщины в агроинновациях». Развивает GovTech-маркетинг.',
      },
      {
        name: 'Ремо Спинелли',
        country: 'Италия',
        role: 'директор по CX и коммуникациям супермаркетов',
        bio: 'Сеть в 6 странах ЕС: customer journey orchestration, AI-платформы и лояльность. Колонка в European Retail Weekly, член CMO Council Europe. Синергия технологии и эмоций в FMCG.',
      },
      {
        name: 'Анастасия Цесаренко',
        country: 'Беларусь',
        role: 'Head of Insights в исследовательской компании',
        bio: '300+ проектов по поведенческому моделированию, запуску брендов, ценам и упаковке. Треки ESOMAR, тренинги ВШМ, юные исследователи.',
      },
      {
        name: 'Дэвид Корнуэль',
        country: 'Франция',
        role: 'креативный директор и motion-дизайнер NomadFrame',
        bio: 'Работал с Renault, Ubisoft, L’Oréal. Лауреат Cannes Lions, D&AD; жюри Eurobest и ADCE. Лектор Motion Design Fest Paris, курс по motion-маркетингу в Parsons Paris.',
      },
      {
        name: 'Женевьева Лойо',
        country: 'Франция/Канада',
        role: 'директор по международным коммуникациям в организации прав человека',
        bio: 'Глобальные awareness-кампании в LinkedIn и TikTok для молодёжи. Спикер Impact Marketing, участница CMO Sustainability Roundtable. Кросс-культурный storytelling и бренд-активизм.',
      },
    ],
  },
  {
    year: '2024',
    members: [
      {
        name: 'Магдалена Вишневска',
        manage: 'ЗАМЕСТИТЕЛЬ ПРЕДСЕДАТЕЛЯ ЖЮРИ',
        country: 'Польша',
        photo: Jury16,
        role: 'вице-президент по маркетингу в финансовой группе',
        bio: 'Курирует маркетинг в 10 странах ЕС. Внедрила customer value modeling и программу цифровой лояльности. Спикер European Banking Forum, ментор Women in FinTech Marketing. Член CMO Council, судья Effie Poland.',
      },
      {
        name: 'Айбек Муратов',
        manage: 'ПРЕДСЕДАТЕЛЬ ЖЮРИ',
        country: 'Казахстан',
        photo: Jury17,
        role: 'директор по маркетингу промышленного холдинга',
        bio: 'Разработал предиктивную аналитику для B2B-продаж и внедрил ESG-коммуникацию для 4000+ сотрудников. Эксперт по устойчивому брендингу в ЦА. Член совета KazMarketing, участник CEE Sustainability Leadership.',
      },
      {
        name: 'Кристель Дювал',
        manage: 'ЗАМЕСТИТЕЛЬ ПРЕДСЕДАТЕЛЯ ЖЮРИ',
        country: 'Франция',
        photo: Jury18,
        role: 'директор по стратегии в глобальном дизайн-агентстве',
        bio: 'Rebranding для Cartier, Orange, Ubisoft. Куратор курса по sustainable design, жюри Cannes Lions France. Консультирует стартапы в Station F.',
      },
      {
        name: 'Максим Журавель',
        country: 'Украина',
        role: 'руководитель потребительской аналитики агрохолдинга',
        bio: 'Внедрил AI-модели поведения покупателей в ритейле. Эксперт food-tech акселераторов, приглашённый эксперт аграрных хабов. Автор курсов BI-аналитики, судья Digital Agri Forum.',
      },
      {
        name: 'Марианна Риккардо',
        country: 'Италия',
        role: 'креативный стратег, директор по контенту',
        bio: 'Webby и Epica-кампании. Специалист digital storytelling для food, mobility и ESG. Преподаёт в Scuola Politecnica di Design, эксперт ADCI Italy.',
      },
      {
        name: 'Гулбахор Махмудова',
        country: 'Узбекистан',
        role: 'директор по маркетингу ритейл-сети',
        bio: 'Ребрендинг, омниканальные решения и customer-driven UX. Участница цифровизации ритейла при Минэкономики. Клуб CMO Central Asia.',
      },
      {
        name: 'Эрик Зайлер',
        country: 'Швейцария',
        role: 'профессор маркетинга в IMD Lausanne',
        bio: 'Исследование «ценностно-ориентированный брендинг» с WARC и ESOMAR. Член редколлегии Journal of Business Research, жюри Global B2B Marketing Awards.',
      },
      {
        name: 'Валентина Дончова',
        country: 'Болгария',
        role: 'основательница digital-агентства',
        bio: 'UX-кейс Webit Festival. Этичный таргетинг и приватность в рекламе. Член IAB Europe.',
      },
      {
        name: 'Самир Ахундов',
        country: 'Азербайджан',
        role: 'PR- и GR-директор энергетической группы',
        bio: 'Антикризисные и социальные коммуникации. Курировал «Зелёный Пояс». Спикер Eurasian Communication Forum, консультант по репутационному маркетингу.',
      },
      {
        name: 'Екатерина Нартова',
        country: 'Молдова',
        role: 'директор по бренд-менеджменту и внутренним коммуникациям',
        bio: 'Геймификация обучения маркетологов, контент-архитектура для внутренних брендов. Победитель HR Brand, участник CMO Camp 2023. Преподаёт Digital HR в IT Park Moldova.',
      },
      {
        name: 'Луиза Караханян',
        country: 'Армения',
        role: 'CX-исследователь и стратег',
        bio: 'UX-редизайн европейской почты. Ментор сервис-дизайна, публикации в UX Collective.',
      },
      {
        name: 'Рафаэль Монтальво',
        country: 'Испания',
        role: 'арт-директор и креативный куратор',
        bio: 'Кампании для Cervantes, Red Bull Music, Valencia Tourism Board. Член Type Directors Club, лектор UAB Barcelona. Жюри Red Dot и European Festival of Illustration.',
      },
    ],
  },
  {
    year: '2025',
    members: [
      {
        name: 'Денис Войцеховский',
        manage: 'ПРЕДСЕДАТЕЛЬ ЖЮРИ',
        country: 'Литва',
        photo: Jury19,
        role: 'стратег по brand-коммуникациям и креативной эффективности',
        bio: 'Эксперт по управлению восприятием бренда (brand lift, favorability, consideration) и построению международных коммуникационных платформ. Участвует в проектах по развитию стандартов ответственного таргетинга и устойчивых коммуникаций. Регулярный спикер отраслевых конференций в Европе и APAC.',
      },
      {
        name: 'Саид Рустамов',
        manage: 'ЗАМЕСТИТЕЛЬ ПРЕДСЕДАТЕЛЯ ЖЮРИ',
        country: 'Узбекистан',
        photo: Jury20,
        role: 'эксперт по martech/adtech-инфраструктуре и автоматизации медиазакупки',
        bio: 'Специализация: ID-графы, server-side измерение, кросс-канальная синхронизация частоты, аудит рекламных решений и качество данных для оптимизации кампаний. Запускал сквозные измерения эффективности и подходы incrementality/holdout для оценки реального вклада рекламы.',
      },
      {
        name: 'Марина Соколенко',
        manage: 'ЗАМЕСТИТЕЛЬ ПРЕДСЕДАТЕЛЯ ЖЮРИ',
        country: 'Беларусь',
        photo: Jury21,
        role: 'менеджер по маркетингу, IKEA',
        bio: 'Практик бренд-коммуникаций и клиентского опыта в омниканальных проектах. Специализируется на построении контент-стратегии, вовлечении сообществ и кросс-функциональном управлении маркетинговыми инициативами (retail + digital).',
      },
      {
        name: 'Renata Azevedo',
        country: 'Португалия',
        role: 'Media Director, Publicis Portugal',
        bio: 'Эксперт по медиастратегии и эффективности инвестиций в коммуникации. Работает с комплексными медиамиксами (digital, TV, OOH), оптимизацией частоты и контролем качества закупки. Ведёт проекты по измерению реального влияния кампаний на продажи и бренд-метрики.',
      },
      {
        name: 'Marco Bellini',
        country: 'Швейцария',
        role: 'Chief Creative Officer, Digitouch mktg',
        bio: 'Креативный руководитель с опытом построения бренд-платформ и кампаний, сочетающих storytelling и технологические форматы. Специализация: креативная эффективность, интегрированные кампании и развитие креативных команд.',
      },
      {
        name: 'Илья Чернов',
        country: 'Армения',
        role: 'Chief Creative Officer, emg',
        bio: 'Отвечает за креативную стратегию и разработку коммуникаций для федеральных брендов. Работает на стыке креатива и performance-подходов: тестирование гипотез, библиотека креативов, масштабирование успешных связок сообщений и форматов.',
      },
      {
        name: 'Nora Bruggen',
        country: 'Global',
        role: 'Joint Head of Data Insights, Wavemaker Global; Global Head of DEI',
        bio: 'Эксперт по data-insights и стратегическим исследованиям. Разрабатывает подходы к измерению эффективности коммуникаций и качеству данных, а также внедряет практики DEI в международных командах и проектах.',
      },
      {
        name: 'Chow Kok',
        country: 'Global',
        role: 'Regional Executive Creative Director, Hakuhodo',
        bio: 'Региональный креативный директор, работающий с брендами в Азии и на глобальных рынках. Специализация: креативная стратегия, культурная адаптация коммуникаций и интеграция digital-форматов в бренд-платформы.',
      },
      {
        name: 'Артём Назаров',
        country: 'Казахстан',
        role: 'CEO, Agenda Media Group',
        bio: 'Практик медиаменеджмента и стратегического планирования. Эксперт по построению медиапродуктов, эффективности закупки и внедрению процессов управления качеством рекламы. Развивает индустриальные инициативы и партнерские экосистемы на рынке.',
      },
      {
        name: 'Вадим Кузнецов',
        country: 'Молдова',
        role: 'Deputy Managing Director, Isobar Moscow (dentsu Russia)',
        bio: 'Руководитель digital-направления с опытом реализации крупных трансформационных проектов для брендов. Специализация: комплексные digital-стратегии, управление delivery-командами, интеграция аналитики и креатива, развитие сервисной модели агентства.',
      },
    ],
  },
];

export default function JuryByYear() {
  const siteUrl = 'https://icmosummitawards.com/jurylist';

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: 'Жюри International CMO Summit Awards по годам',
    url: siteUrl,
    description:
      'Состав жюри International CMO Summit Awards за 2019–2025 годы, включая Vadym Larikov.',
    mentions: [
      {
        '@type': 'Person',
        name: 'Vadym Larikov',
        alternateName: 'Вадим Лариков',
        jobTitle: 'Chair of Jury',
        description:
          'Председатель жюри International CMO Summit Awards 2021, директор по маркетингу агентства UAMASTER.',
      },
    ],
  };

  useEffect(() => {
  function isGoogleTranslated() {
    const html = document.documentElement;
    const body = document.body;

    return (
      html.classList.contains('translated-ltr') ||
      html.classList.contains('translated-rtl') ||
      body.classList.contains('translated-ltr') ||
      body.classList.contains('translated-rtl') ||
      document.cookie.indexOf('googtrans=') !== -1 ||
      html.getAttribute('lang') !== 'ru'
    );
  }

  function fixValue(text) {
    if (!text) return text;

    return text
      .replace(/\bVadim Larikov's\b/g, "Vadym Larikov's")
      .replace(/\bVADIM LARIKOV'S\b/g, "VADYM LARIKOV'S")
      .replace(/\bVadim Larikov\b/g, 'Vadym Larikov')
      .replace(/\bVADIM LARIKOV\b/g, 'VADYM LARIKOV')
      .replace(/\bVadim's\b/g, "Vadym's")
      .replace(/\bVADIM'S\b/g, "VADYM'S")
      .replace(/\bVadim\b/g, 'Vadym')
      .replace(/\bVADIM\b/g, 'VADYM');
  }

  function shouldSkipNode(parent) {
    if (!parent || !parent.tagName) return true;

    const tag = parent.tagName.toUpperCase();
    return (
      tag === 'SCRIPT' ||
      tag === 'STYLE' ||
      tag === 'NOSCRIPT' ||
      tag === 'TEXTAREA' ||
      tag === 'CODE' ||
      tag === 'PRE'
    );
  }

  function fixTextNodes(root) {
    if (!root) return;

    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          if (!node || !node.nodeValue || !node.nodeValue.trim()) {
            return NodeFilter.FILTER_REJECT;
          }

          if (shouldSkipNode(node.parentNode)) {
            return NodeFilter.FILTER_REJECT;
          }

          if (
            node.nodeValue.indexOf('Vadim') === -1 &&
            node.nodeValue.indexOf('VADIM') === -1
          ) {
            return NodeFilter.FILTER_REJECT;
          }

          return NodeFilter.FILTER_ACCEPT;
        },
      }
    );

    const nodes = [];
    let current;

    while ((current = walker.nextNode())) {
      nodes.push(current);
    }

    nodes.forEach((node) => {
      const fixed = fixValue(node.nodeValue);
      if (fixed !== node.nodeValue) {
        node.nodeValue = fixed;
      }
    });
  }

  function fixAttributes() {
    const selectors = [
      'title',
      'meta[name="description"]',
      'meta[name="keywords"]',
      'meta[property="og:title"]',
      'meta[property="og:description"]',
      'meta[name="twitter:title"]',
      'meta[name="twitter:description"]',
      'img[alt]'
    ];

    selectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        if (el.tagName.toLowerCase() === 'title') {
          const fixedText = fixValue(el.textContent);
          if (fixedText !== el.textContent) {
            el.textContent = fixedText;
          }
        } else if (el.tagName.toLowerCase() === 'img') {
          const alt = el.getAttribute('alt');
          const fixedAlt = fixValue(alt);
          if (fixedAlt !== alt) {
            el.setAttribute('alt', fixedAlt);
          }
        } else {
          const content = el.getAttribute('content');
          const fixedContent = fixValue(content);
          if (fixedContent !== content) {
            el.setAttribute('content', fixedContent);
          }
        }
      });
    });

    if (document.title) {
      const fixedTitle = fixValue(document.title);
      if (fixedTitle !== document.title) {
        document.title = fixedTitle;
      }
    }
  }

  function runFixes() {
    if (!isGoogleTranslated()) return;
    fixTextNodes(document.body);
    fixAttributes();
  }

  let started = false;
  let mainObserver = null;
  let pollInterval = null;
  let translationWatcher = null;

  function startAfterTranslate() {
    if (started) return;
    started = true;

    runFixes();

    mainObserver = new MutationObserver(() => {
      runFixes();
    });

    if (document.body) {
      mainObserver.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    let count = 0;
    pollInterval = setInterval(() => {
      runFixes();
      count += 1;

      if (count > 180) {
        clearInterval(pollInterval);
      }
    }, 1000);
  }

  function waitForTranslate() {
    if (isGoogleTranslated()) {
      startAfterTranslate();
      return;
    }

    translationWatcher = new MutationObserver(() => {
      if (isGoogleTranslated()) {
        startAfterTranslate();
      }
    });

    translationWatcher.observe(document.documentElement, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['class', 'lang'],
    });

    const translateCheckInterval = setInterval(() => {
      if (isGoogleTranslated()) {
        startAfterTranslate();
        clearInterval(translateCheckInterval);
      }
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForTranslate);
  } else {
    waitForTranslate();
  }

  return () => {
    if (mainObserver) mainObserver.disconnect();
    if (translationWatcher) translationWatcher.disconnect();
    if (pollInterval) clearInterval(pollInterval);
  };
}, []);

  return (
    <article className="jury-page">
      <Helmet>
        <html lang="ru" />
        <title>Жюри International CMO Summit Awards | Vadym Larikov</title>

        <meta
          name="description"
          content="Жюри International CMO Summit Awards по годам: международные эксперты 2019–2025, включая Vadym Larikov (Вадим Лариков) как председателя жюри 2021 года."
        />
        <meta
          name="keywords"
          content="Vadym Larikov, Вадим Лариков, жюри International CMO Summit Awards, председатель жюри 2021, маркетинговая премия, международное жюри"
        />
        <link rel="canonical" href={siteUrl} />

        <meta property="og:type" content="website" />
        <meta property="og:title" content="Жюри International CMO Summit Awards | Vadym Larikov" />
        <meta
          property="og:description"
          content="Жюри International CMO Summit Awards по годам, включая Vadym Larikov."
        />
        <meta property="og:url" content={siteUrl} />
        <meta property="og:image" content="https://icmosummitawards.com/preview.png" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Жюри International CMO Summit Awards | Vadym Larikov" />
        <meta
          name="twitter:description"
          content="Состав жюри International CMO Summit Awards, включая Vadym Larikov."
        />
        <meta name="twitter:image" content="https://icmosummitawards.com/preview.png" />

        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      <section className="section-organizer jury-policy__intro">
        <h1 className="section-title">Жюри International CMO Summit Awards по годам (2019–2025)</h1>
        <p className="jury-policy__subtitle">
          Каждый год в состав жюри входит не менее 12 экспертов. Мы соблюдаем баланс между практиками из СНГ и Европы, отбирая профессионалов с подтвержденными достижениями в маркетинге, стратегиях, коммуникациях и цифровой трансформации.
        </p>

        <div className="jury-policy__intro-image">
          <img src={IntroImage} alt="Победители International CMO Summit Awards" />
        </div>

        <div className="seo-hidden">
          Vadym Larikov, Вадим Лариков, Chairman of Jury 2021, International CMO Summit Awards jury,
          UAMASTER marketing director, international marketing awards jury member.
        </div>
      </section>

      {juryByYear.map(({ year, members }) => {
        const withPhoto = members.slice(0, 3);
        const withoutPhoto = members.slice(3);

        return (
          <section key={year} className="jury-year">
            <h2 className="year-title">Жюри {year} года</h2>

            <div className="jury-photo-row">
              {withPhoto.map((m, i) => (
                <div key={i} className="jury-card with-photo">
                  {m.manage && <h3 className="member-manage">{m.manage}</h3>}
                  <div className="photo-wrapper">
                    <img
                      src={m.photo}
                      alt={
                        m.name === 'Вадим Лариков'
                          ? 'Vadym Larikov — Chairman of Jury 2021'
                          : m.name
                      }
                    />
                  </div>
                  <h3 className="member-name">{m.name}</h3>
                  <p className="role">
                    <em>{m.country}</em>, {m.role}
                  </p>
                  <p className="bio">{m.bio}</p>

                  {m.name === 'Вадим Лариков' && (
                    <span className="seo-hidden">
                      Vadym Larikov
                    </span>
                  )}
                </div>
              ))}
            </div>

            <div className="jury-grid">
              {withoutPhoto.map((m, i) => (
                <div key={i} className="jury-card">
                  <h3 className="member-name">{m.name}</h3>
                  <p className="role">
                    <em>{m.country}</em>, {m.role}
                  </p>
                  <p className="bio">{m.bio}</p>

                  {m.name === 'Вадим Лариков' && (
                    <span className="seo-hidden">
                      Vadym Larikov
                    </span>
                  )}
                </div>
              ))}
            </div>
          </section>
        );
      })}
    </article>
  );
}